// Generated by pnpm gen:icons
import type { SVGAttributes } from "react";

export const IconArrowBlockUp = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconArrowBlockUp"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M13.8,20h-3.6c-.3,0-.5,0-.7-.1-.2,0-.3-.3-.4-.4-.1-.2-.1-.4-.1-.7v-7.8h-2.7c-.2,0-.5-.1-.6-.4,0-.2,0-.5.1-.7l5.7-5.7c.2-.2.6-.2.9,0l5.7,5.7c.2.2.2.4.1.7s-.3.4-.6.4h-2.7v7.8c0,.3,0,.5-.1.7-.1.2-.3.3-.4.4-.2.1-.4.1-.7.1ZM7.7,9.7h1.8c.3,0,.6.3.6.6v8.4h0s0,0,0,0h3.7v-8.4c0-.3.3-.6.6-.6h1.8l-4.3-4.3-4.3,4.3Z" />
  </svg>
);

export const IconArrowLeft = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconArrowLeft"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M11.72 4.045c-.076.023-.22.102-.32.176-.099.074-1.766 1.724-3.704 3.666-2.402 2.409-3.547 3.584-3.599 3.693-.1.215-.101.625 0 .84.105.224 7.259 7.378 7.483 7.483.211.099.627.101.824.004.19-.093.382-.284.488-.485.112-.213.117-.615.01-.842-.05-.108-.956-1.043-2.777-2.869l-2.702-2.71 5.918-.01c5.603-.01 5.927-.015 6.063-.083.191-.095.382-.286.488-.486.11-.21.117-.617.014-.828a1.268 1.268 0 0 0-.5-.501c-.139-.069-.438-.074-6.065-.084l-5.919-.01 2.685-2.69c1.853-1.855 2.713-2.745 2.777-2.869.118-.229.128-.629.022-.846a1.242 1.242 0 0 0-.493-.495 1.192 1.192 0 0 0-.693-.054" />
  </svg>
);

export const IconArrowNarrowDown = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconArrowNarrowDown"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 16 16"
    role="img"
    {...props}
  >
    <path d="M7.902 2.187 C 7.759 2.219,7.643 2.304,7.573 2.428 L 7.507 2.547 7.500 7.333 L 7.493 12.119 5.900 10.529 C 5.024 9.654,4.266 8.918,4.215 8.893 C 3.995 8.782,3.696 8.874,3.577 9.089 C 3.501 9.228,3.493 9.417,3.560 9.549 C 3.620 9.669,7.607 13.664,7.754 13.752 C 7.910 13.844,8.090 13.844,8.246 13.752 C 8.393 13.664,12.380 9.669,12.440 9.549 C 12.647 9.137,12.183 8.688,11.772 8.902 C 11.709 8.934,11.026 9.598,10.093 10.532 L 8.520 12.107 8.507 7.327 L 8.493 2.547 8.423 2.426 C 8.315 2.244,8.096 2.143,7.902 2.187" />
  </svg>
);

export const IconArrowNarrowRight = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconArrowNarrowRight"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M14,19c-.3,0-.5,0-.7-.3-.4-.4-.4-1,0-1.4l4.3-4.3H4c-.6,0-1-.4-1-1s.4-1,1-1h13.6l-4.3-4.3c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l6,6c0,0,.2.2.2.3,0,.1,0,.2,0,.4h0c0,.1,0,.3,0,.4,0,.1-.1.2-.2.3l-6,6c-.2.2-.5.3-.7.3Z" />
  </svg>
);

export const IconArrowNarrowUp = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconArrowNarrowUp"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 16 16"
    role="img"
    {...props}
  >
    <path d="M7.907 2.186 C 7.863 2.196,7.791 2.224,7.747 2.247 C 7.631 2.309,3.614 6.342,3.559 6.451 C 3.358 6.855,3.813 7.309,4.215 7.107 C 4.266 7.082,5.024 6.346,5.900 5.471 L 7.493 3.881 7.500 8.667 L 7.507 13.453 7.577 13.574 C 7.771 13.903,8.237 13.900,8.427 13.569 L 8.493 13.453 8.500 8.667 L 8.507 3.881 10.100 5.471 C 10.976 6.346,11.734 7.082,11.785 7.107 C 12.188 7.309,12.642 6.854,12.440 6.451 C 12.381 6.332,8.393 2.336,8.253 2.255 C 8.128 2.182,8.018 2.160,7.907 2.186" />
  </svg>
);

export const IconArrowRight = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconArrowRight"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 14 14"
    role="img"
    {...props}
  >
    <path d="M6.515.026c-.529.089-.823.684-.585 1.183.041.084.573.631 2.305 2.367l2.253 2.257-4.818.001c-3.205 0-4.868.008-4.967.024a.8.8 0 0 0-.677.67.828.828 0 0 0 .464.89l.128.06 4.93.006c2.711.004 4.929.014 4.929.023 0 .01-1.013 1.031-2.25 2.27-1.505 1.506-2.265 2.283-2.297 2.348a.9.9 0 0 0 .001.748.923.923 0 0 0 .392.378c.11.052.161.061.35.061.197 0 .236-.008.352-.066.109-.055.631-.567 3.153-3.092 2.443-2.446 3.033-3.048 3.078-3.142.047-.098.056-.153.056-.339 0-.398.274-.091-3.09-3.46C8.585 1.573 7.192.196 7.128.154a.817.817 0 0 0-.613-.128" />
  </svg>
);

export const IconAsterisk = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconAsterisk"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M12,21c-.6,0-1-.4-1-1v-5.6l-4.3,4.3c-.4.4-1,.4-1.4,0s-.4-1,0-1.4l4.3-4.3h-5.6c-.6,0-1-.4-1-1s.4-1,1-1h5.6l-4.3-4.3c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l4.3,4.3v-5.6c0-.6.4-1,1-1s1,.4,1,1v5.6l4.3-4.3c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-4.3,4.3h5.6c.6,0,1,.4,1,1s-.4,1-1,1h-5.6l4.3,4.3c.4.4.4,1,0,1.4s-1,.4-1.4,0l-4.3-4.3v5.6c0,.6-.4,1-1,1Z" />
  </svg>
);

export const IconCertificate = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCertificate"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    role="img"
    {...props}
  >
    <path d="M23.698,27.917L21.141,30.474C20.653,30.962 19.861,30.962 19.373,30.474L16.014,27.115L12.655,30.474C12.421,30.708 12.103,30.84 11.772,30.84C11.44,30.84 11.122,30.709 10.888,30.474L8.33,27.917L6.667,27.917C4.504,27.917 2.75,26.163 2.75,24L2.75,5.333C2.75,3.17 4.504,1.417 6.667,1.417L25.333,1.417C27.496,1.417 29.25,3.17 29.25,5.333L29.25,24C29.25,26.163 27.496,27.917 25.333,27.917L23.698,27.917ZM6.817,25.417C6.878,25.237 6.98,25.072 7.116,24.935L10.75,21.301C10.767,18.417 13.111,16.083 16,16.083C18.879,16.083 21.217,18.401 21.25,21.273L24.912,24.935C25.052,25.075 25.152,25.241 25.212,25.417L25.333,25.417C26.116,25.417 26.75,24.782 26.75,24L26.75,5.333C26.75,4.551 26.116,3.917 25.333,3.917L6.667,3.917C5.884,3.917 5.25,4.551 5.25,5.333L5.25,24C5.25,24.782 5.884,25.417 6.667,25.417L6.817,25.417ZM13.593,26.001C12.737,25.558 12.019,24.888 11.518,24.069L9.768,25.819L11.772,27.822L13.593,26.001ZM20.493,24.051C19.995,24.872 19.279,25.545 18.425,25.991L20.257,27.822L22.261,25.819L20.493,24.051ZM16,24.084C16.005,24.083 16.01,24.083 16.015,24.083C17.527,24.076 18.75,22.847 18.75,21.333C18.75,19.815 17.519,18.583 16,18.583C14.481,18.583 13.25,19.815 13.25,21.333C13.25,22.852 14.481,24.084 16,24.084ZM12,9.25C11.31,9.25 10.75,8.69 10.75,8C10.75,7.31 11.31,6.75 12,6.75L20,6.75C20.69,6.75 21.25,7.31 21.25,8C21.25,8.69 20.69,9.25 20,9.25L12,9.25ZM9.333,13.917C8.643,13.917 8.083,13.357 8.083,12.667C8.083,11.977 8.643,11.417 9.333,11.417L22.667,11.417C23.357,11.417 23.917,11.977 23.917,12.667C23.917,13.357 23.357,13.917 22.667,13.917L9.333,13.917Z" />
  </svg>
);

export const IconCheckHeart = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCheckHeart"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M12,21.7c-.7,0-1.3-.4-1.7-.8-2.3-2-6.3-5.7-7.8-7.6C.1,10.2.6,6,3.5,3.5c2.5-2.1,6-2,8.5.2,2.5-2.2,5.9-2.3,8.5-.2,2.9,2.4,3.4,6.6,1,9.6-1.5,1.9-5.5,5.8-7.8,7.8-.4.4-1,.8-1.7.8ZM7.6,4c-.9,0-1.9.3-2.8,1.1-2.1,1.8-2.4,4.7-.8,6.9,1.5,1.9,5.8,5.8,7.6,7.4.2.2.3.3.4.4,0,0,6.4-5.9,7.9-7.8,1.7-2.2,1.4-5.1-.7-6.9-2.2-1.9-4.9-1.1-6.4.7-.4.4-1.1.4-1.5,0-.9-1.1-2.3-1.8-3.7-1.8ZM11,14c-.3,0-.5,0-.7-.3l-2-2c-.4-.4-.4-1,0-1.4.4-.4,1-.4,1.4,0l1.3,1.3,3.8-3.8c.4-.4,1-.4,1.4,0,.4.4.4,1,0,1.4l-4.5,4.5c-.2.2-.5.3-.7.3Z" />
  </svg>
);

export const IconCheckVerified = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCheckVerified"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    role="img"
    {...props}
  >
    <path
      d="M10.667 1.548c-.936.24-1.823.849-2.312 1.588-.235.354-.313.524-1.04 2.269-.206.494-.43.98-.498 1.08-.182.269-.431.422-1.225.75-2.263.936-2.598 1.117-3.104 1.677a3.898 3.898 0 0 0-1.031 2.875c.034.689.077.83.731 2.426.628 1.534.674 1.694.589 2.04-.034.14-.302.835-.595 1.546-.293.711-.58 1.477-.637 1.702-.385 1.504.303 3.295 1.591 4.143.324.213.781.421 2.604 1.18.974.407 1.043.484 1.563 1.739.688 1.664.819 1.951 1.052 2.301.676 1.02 1.97 1.696 3.245 1.696.674 0 1.067-.112 2.595-.739 1.552-.637 1.712-.683 2.058-.598.14.034.835.302 1.546.595.711.293 1.477.58 1.702.637 1.504.385 3.295-.303 4.143-1.591.213-.324.384-.701 1.178-2.602.282-.674.428-.895.719-1.091.113-.076.718-.349 1.345-.608a40.327 40.327 0 0 0 1.514-.653c.963-.472 1.666-1.318 2.008-2.417.103-.333.124-.515.123-1.093-.001-.845-.017-.906-.719-2.613-.626-1.522-.675-1.691-.589-2.04.034-.14.302-.835.595-1.546.293-.711.58-1.477.637-1.702.385-1.504-.301-3.289-1.591-4.144-.354-.235-.524-.313-2.27-1.041-.984-.41-1.223-.551-1.414-.833-.069-.103-.351-.727-.625-1.387-.581-1.4-.755-1.762-1.013-2.114-.476-.648-1.359-1.216-2.231-1.434a3.987 3.987 0 0 0-1.805-.003c-.222.057-.992.345-1.71.64-1.481.608-1.73.679-2.071.59-.127-.033-.813-.299-1.524-.592-.711-.292-1.477-.579-1.702-.636a4.105 4.105 0 0 0-1.832.003m2.666 2.949c1.791.739 1.849.755 2.667.756.807 0 .929-.034 2.587-.722 1.709-.711 1.766-.723 2.303-.523.586.22.692.372 1.347 1.95.618 1.49.781 1.813 1.118 2.218.523.628.87.833 2.681 1.586 1.645.683 1.789.789 2.002 1.465.14.445.143.435-.573 2.186-.699 1.712-.717 1.776-.717 2.587 0 .812.018.879.719 2.587.289.704.553 1.387.587 1.517.074.28.038.559-.117.919-.196.456-.432.609-1.841 1.188-1.413.58-1.819.783-2.253 1.125-.615.485-.885.941-1.637 2.771-.607 1.476-.747 1.676-1.326 1.891-.49.182-.667.143-2.213-.495-1.793-.739-1.849-.755-2.667-.755-.821 0-.882.017-2.667.76-1.278.532-1.382.566-1.733.569-.292.001-.428-.026-.624-.125-.488-.249-.585-.402-1.217-1.922-.613-1.477-.737-1.725-1.088-2.179-.471-.61-.952-.895-2.778-1.645-1.119-.46-1.31-.556-1.526-.766-.265-.258-.474-.714-.474-1.034 0-.236.034-.332.642-1.819.699-1.712.717-1.776.717-2.587 0-.812-.018-.876-.718-2.587a45.585 45.585 0 0 1-.589-1.487c-.084-.268-.036-.667.117-.973.23-.458.437-.589 1.885-1.186 1.8-.743 2.177-.965 2.698-1.591.336-.403.494-.717 1.114-2.206.594-1.429.689-1.593 1.075-1.84.567-.362.825-.324 2.499.367m7.094 6.967a1.43 1.43 0 0 0-.32.105c-.074.038-1.328 1.26-2.787 2.716l-2.653 2.648-1-.998c-.634-.633-1.073-1.028-1.199-1.08-.446-.184-1.02-.058-1.359.298-.338.357-.435.922-.234 1.354.065.138.638.747 1.639 1.742 1.628 1.616 1.664 1.644 2.153 1.644.513 0 .4.097 3.803-3.297 1.855-1.851 3.236-3.269 3.298-3.388.147-.283.148-.796.003-1.078a1.244 1.244 0 0 0-1.344-.666"
      fillRule="evenodd"
    />
  </svg>
);

export const IconCheckmark = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCheckmark"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M9,18c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L9,15.6L19.3,5.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-11,11C9.5,17.9,9.3,18,9,18z" />
  </svg>
);

export const IconCheckmarkSmall = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCheckmarkSmall"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 14 14"
    role="img"
    {...props}
  >
    <path d="M5.2,10.9h0c-.3,0-.5-.1-.7-.3l-2.9-2.9c-.4-.4-.4-1,0-1.4.4-.4,1-.4,1.4,0l2.2,2.2,5.7-5.7c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-6.4,6.4c-.2.2-.4.3-.7.3Z" />
  </svg>
);

export const IconChevronRight = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconChevronRight"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 20 20"
    role="img"
    fill="#475467"
    {...props}
  >
    <path d="M7.5,15.8c-.2,0-.4,0-.6-.2-.3-.3-.3-.9,0-1.2l4.4-4.4-4.4-4.4c-.3-.3-.3-.9,0-1.2.3-.3.9-.3,1.2,0l5,5c.3.3.3.9,0,1.2l-5,5c-.2.2-.4.2-.6.2Z" />
  </svg>
);

export const IconClock = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconClock"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M12,23c-6.1,0-11-4.9-11-11S5.9,1,12,1s11,4.9,11,11-4.9,11-11,11ZM12,3C7,3,3,7,3,12s4,9,9,9,9-4,9-9S17,3,12,3ZM16,15c-.2,0-.3,0-.4-.1l-4-2c-.3-.2-.6-.5-.6-.9v-6c0-.6.4-1,1-1s1,.4,1,1v5.4l3.4,1.7c.5.2.7.8.4,1.3-.2.4-.5.6-.9.6Z" />
  </svg>
);

export const IconCompass = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCompass"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M12,23c-6.07,0-11-4.93-11-11S5.93,1,12,1s11,4.93,11,11-4.93,11-11,11ZM12,3C7.04,3,3,7.04,3,12s4.04,9,9,9,9-4.04,9-9S16.96,3,12,3Z" />
    <path d="M8.5,16.94c-.15,0-.3-.02-.45-.08-.42-.15-.75-.48-.91-.91-.17-.49-.03-.91.18-1.54l1.49-4.46c.06-.17.11-.34.23-.51.1-.15.24-.29.39-.39.17-.12.33-.17.51-.23l4.47-1.49h0l.32.95-.31-.95c.64-.21,1.05-.35,1.54-.18.42.15.76.48.91.91.17.48.03.9-.17,1.53l-1.49,4.48c-.06.17-.11.34-.23.51-.11.16-.24.29-.4.4-.18.12-.34.17-.52.23l-4.46,1.49c-.44.15-.77.26-1.1.26ZM9.06,15.55h0ZM10.67,10.67l-1.33,3.99,3.99-1.33,1.33-3.99-3.99,1.33ZM15.55,9.06h0ZM14.72,8.27l.15.45s0,0,0,0l-.15-.44Z" />
  </svg>
);

export const IconCornerDownLeft = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCornerDownLeft"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 16 16"
    role="img"
    {...props}
  >
    <path d="M6,13.8c-.1,0-.3,0-.4-.1l-3.3-3.3s0,0,0,0h0s0,0,0-.1c0,0,0-.1,0-.2s0-.1,0-.2c0,0,0-.1.1-.2,0,0,0,0,0,0l3.3-3.3c.2-.2.5-.2.7,0s.2.5,0,.7l-2.5,2.5h3.1c2.2,0,3.2,0,4-.4.7-.3,1.2-.9,1.5-1.5.4-.7.4-1.8.4-4v-.9c0-.3.2-.5.5-.5s.5.2.5.5v.9c0,2.3,0,3.5-.5,4.4-.4.9-1.1,1.5-2,2-1,.5-2.1.5-4.4.5h-3.1l2.5,2.5c.2.2.2.5,0,.7s-.2.1-.4.1Z" />
  </svg>
);

export const IconCross = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconCross"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 20 20"
    role="img"
    {...props}
  >
    <g>
      <path d="M15,5L5,15 M5,5l10,10" />
      <path d="M15,15.8c-0.2,0-0.4-0.1-0.6-0.2L10,11.2l-4.4,4.4c-0.3,0.3-0.9,0.3-1.2,0c-0.3-0.3-0.3-0.9,0-1.2L8.8,10L4.4,5.6c-0.3-0.3-0.3-0.9,0-1.2c0.3-0.3,0.9-0.3,1.2,0L10,8.8l4.4-4.4c0.3-0.3,0.9-0.3,1.2,0c0.3,0.3,0.3,0.9,0,1.2L11.2,10l4.4,4.4c0.3,0.3,0.3,0.9,0,1.2C15.4,15.8,15.2,15.8,15,15.8z" />
    </g>
  </svg>
);

export const IconDot = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconDot"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M11.9999 18.6667C15.6818 18.6667 18.6666 15.6819 18.6666 12C18.6666 8.31811 15.6818 5.33334 11.9999 5.33334C8.31802 5.33334 5.33325 8.31811 5.33325 12C5.33325 15.6819 8.31802 18.6667 11.9999 18.6667Z" />
  </svg>
);

export const IconDownload = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconDownload"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    fill="#475467"
    {...props}
  >
    <path
      d="M6.92 1.041c-.767.051-1.247.164-1.74.41A3.776 3.776 0 0 0 3.124 4.16C3.012 4.738 3 5.47 3 12c0 7.433.002 7.515.245 8.32.332 1.102 1.333 2.103 2.435 2.435.78.235 1.036.245 6.32.245 5.284 0 5.54-.01 6.32-.245 1.102-.332 2.103-1.333 2.435-2.435.238-.79.245-.984.245-7.023 0-4.915-.006-5.462-.065-5.64-.059-.18-.338-.47-3.21-3.341-2.124-2.123-3.197-3.169-3.305-3.22-.153-.073-.31-.076-3.6-.08-1.892-.003-3.647.009-3.9.025m6.081 4.029c0 2.252.013 2.411.226 2.849.139.286.568.715.854.854.438.213.596.226 2.851.226L19.004 9l-.015 5.11c-.016 5.555-.009 5.373-.237 5.842-.126.259-.562.686-.834.816-.447.215-.371.212-5.918.212-5.538 0-5.467.003-5.918-.209-.27-.128-.705-.554-.834-.819a2.86 2.86 0 0 1-.16-.48c-.063-.27-.068-.842-.068-7.472 0-6.63.005-7.202.068-7.472.087-.373.206-.61.432-.861.364-.406.763-.577 1.46-.627.22-.015 1.665-.031 3.21-.034L13 3l.001 2.07m3.299.65L17.58 7H15V5.72c0-.704.005-1.28.01-1.28.006 0 .586.576 1.29 1.28m-4.605 5.337a1.04 1.04 0 0 0-.567.459l-.108.184-.011 1.935-.012 1.936-.728-.719c-.614-.605-.76-.729-.926-.785a1 1 0 0 0-1.215.449c-.091.156-.108.23-.108.484s.016.328.107.48c.134.224 3.241 3.324 3.433 3.425.1.052.226.073.44.073s.34-.021.44-.073c.192-.101 3.299-3.201 3.433-3.425.091-.152.107-.226.107-.48s-.017-.328-.108-.484a1 1 0 0 0-1.215-.449c-.166.056-.312.18-.926.785l-.728.719-.012-1.936-.011-1.935-.108-.184a1.005 1.005 0 0 0-1.177-.459"
      fillRule="evenodd"
    />
  </svg>
);

export const IconEdit = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconEdit"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M5.84,19.65c-.26,0-.52-.1-.71-.29-.21-.21-.32-.52-.29-.82l.25-2.26c.03-.31.06-.51.13-.74.07-.2.16-.39.27-.57.13-.2.28-.35.5-.56l6.79-6.79s0,0,.01-.01c0,0,0,0,.01-.01l1.99-1.99c1.12-1.12,2.96-1.13,4.08,0s1.12,2.96,0,4.08l-8.8,8.8c-.22.22-.36.36-.56.5-.18.12-.37.21-.57.27-.22.07-.42.09-.71.13l-2.28.25s-.07,0-.11,0ZM13.51,9.73l-6.1,6.1c-.12.12-.19.18-.24.25-.06.16-.06.25-.08.42l-.11,1.02,1.01-.11c.18-.02.27-.02.34-.04.15-.08.21-.15.33-.28l6.1-6.1-1.25-1.25ZM14.92,8.31l1.25,1.25,1.29-1.29c.34-.35.34-.91,0-1.25s-.91-.35-1.25,0l-1.29,1.29Z" />
  </svg>
);

export const IconError = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconError"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    fill="#d03651"
    {...props}
  >
    <path d="M12,22.9c-.1,0-.3,0-.4,0-.3,0-.5-.2-.8-.4l-7.4-4.1c-.4-.2-.6-.3-.8-.6-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-1V7.9c0-.4,0-.7.1-1,0-.3.2-.5.4-.7.2-.2.5-.4.8-.6L10.7,1.6c.3-.2.6-.3.9-.4.3,0,.5,0,.8,0,.3,0,.5.2.9.4l7.4,4.1c.3.2.6.3.8.6.2.2.3.5.4.7,0,.3,0,.6,0,1v8.1c0,.4,0,.7-.1,1,0,.3-.2.5-.4.7-.2.2-.5.4-.8.6l-7.4,4.1c-.3.2-.6.3-.9.4-.1,0-.3,0-.4,0ZM12,3.1s-.1,0-.3.2l-7.4,4.1c-.2,0-.3.1-.3.2,0,0,0,.2,0,.3v8.1c0,.2,0,.3,0,.4,0,0,.1,0,.3.1l7.4,4.1c.2,0,.2.1.3.2,0,0,.1,0,.3-.2l7.4-4.1c.2,0,.3-.1.3-.2,0,0,0-.2,0-.3V7.9c0-.2,0-.3,0-.4,0,0-.1,0-.3-.1l-7.4-4.1c-.1,0-.2-.1-.3-.2ZM12,17c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1ZM12,13c-.6,0-1-.4-1-1v-4c0-.6.4-1,1-1s1,.4,1,1v4c0,.6-.4,1-1,1Z" />
  </svg>
);

export const IconFile = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconFile"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path
      d="M6.92 1.041c-.767.051-1.247.164-1.74.41A3.776 3.776 0 0 0 3.124 4.16C3.012 4.738 3 5.47 3 12c0 7.433.002 7.515.245 8.32.332 1.102 1.333 2.103 2.435 2.435.78.235 1.036.245 6.32.245 5.284 0 5.54-.01 6.32-.245 1.102-.332 2.103-1.333 2.435-2.435.238-.79.245-.984.245-7.023 0-4.915-.006-5.462-.065-5.64-.059-.18-.338-.47-3.21-3.341-2.124-2.123-3.197-3.169-3.305-3.22-.153-.073-.31-.076-3.6-.08-1.892-.003-3.647.009-3.9.025m6.081 4.029c0 2.252.013 2.411.226 2.849.139.286.568.715.854.854.438.213.596.226 2.851.226L19.004 9l-.015 5.11c-.016 5.555-.009 5.373-.237 5.842-.126.259-.562.686-.834.816-.447.215-.371.212-5.918.212-5.538 0-5.467.003-5.918-.209-.27-.128-.705-.554-.834-.819a2.86 2.86 0 0 1-.16-.48c-.063-.27-.068-.842-.068-7.472 0-6.63.005-7.202.068-7.472.087-.373.206-.61.432-.861.364-.406.763-.577 1.46-.627.22-.015 1.665-.031 3.21-.034L13 3l.001 2.07m3.299.65L17.58 7H15V5.72c0-.704.005-1.28.01-1.28.006 0 .586.576 1.29 1.28M7.695 8.057a1.04 1.04 0 0 0-.567.459c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.215.077 2.445.077 2.66 0 .221-.079.414-.241.539-.454.095-.161.111-.233.111-.489 0-.254-.017-.328-.108-.484a1.02 1.02 0 0 0-.582-.461c-.251-.076-2.353-.074-2.595.002m0 4a1.04 1.04 0 0 0-.567.459c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.222.079 8.438.079 8.66 0 .221-.079.414-.241.539-.454.095-.161.111-.233.111-.489 0-.254-.017-.328-.108-.484a1.02 1.02 0 0 0-.582-.461c-.261-.079-8.344-.076-8.595.002m0 4a1.04 1.04 0 0 0-.567.459c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.222.079 8.438.079 8.66 0 .221-.079.414-.241.539-.454.095-.161.111-.233.111-.489 0-.254-.017-.328-.108-.484a1.02 1.02 0 0 0-.582-.461c-.261-.079-8.344-.076-8.595.002"
      fillRule="evenodd"
    />
  </svg>
);

export const IconFilePlus = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconFilePlus"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path
      d="M5.544.885c-.921.089-1.548.388-2.151 1.027-.462.49-.731 1.075-.841 1.828-.076.526-.076 11.994 0 12.52.112.766.381 1.342.863 1.85.587.618 1.163.894 2.104 1.009.195.024 1.256.041 2.5.04 2.004-.001 2.173-.006 2.321-.074a.875.875 0 0 0 .499-.785c-.002-.273-.282-.658-.536-.736-.068-.021-1.129-.047-2.363-.058-2.418-.022-2.607-.037-2.956-.241a2.05 2.05 0 0 1-.618-.653c-.186-.365-.186-.356-.186-6.612 0-6.26 0-6.246.187-6.613.122-.239.443-.559.682-.679.116-.059.337-.124.491-.146.378-.054 8.542-.054 8.92 0 .361.051.653.2.896.458.231.244.341.446.404.742.031.145.052 1.03.064 2.658.01 1.45.034 2.5.058 2.588.076.281.347.507.68.567.385.07.826-.245.913-.651.055-.255.059-3.393.006-4.504-.061-1.279-.264-1.861-.874-2.508-.623-.66-1.22-.937-2.227-1.031-.534-.05-8.312-.046-8.836.004m.794 4.19a1.1 1.1 0 0 0-.306.241c-.388.455-.154 1.173.431 1.32.241.061 6.833.061 7.074 0 .585-.147.819-.865.431-1.32-.288-.336-.019-.314-3.968-.314-3.315 0-3.509.004-3.662.073m.182 3.282c-.645.131-.901.855-.474 1.34.281.32.143.307 3.197.294l2.704-.011.167-.116a.83.83 0 0 0 .36-.539c.095-.422-.197-.868-.628-.96-.234-.05-5.081-.057-5.326-.008m-.244 3.416c-.097.051-.23.17-.296.264-.107.151-.12.202-.12.463s.013.312.12.463c.066.094.199.213.296.264.172.09.205.093 1.224.093s1.052-.003 1.224-.093c.097-.051.23-.17.296-.264.107-.151.12-.202.12-.463s-.013-.312-.12-.463a1.004 1.004 0 0 0-.296-.264c-.172-.09-.205-.093-1.224-.093s-1.052.003-1.224.093m8.384-.027a.976.976 0 0 0-.424.434c-.065.141-.074.27-.075 1.067l-.001.907-.95.013c-1.045.014-1.069.019-1.318.28-.159.166-.212.304-.212.553 0 .248.053.386.212.555.25.264.342.283 1.358.284l.91.001.001.91c.001 1.016.02 1.108.284 1.358.169.159.307.212.555.212.248 0 .386-.053.555-.212.264-.25.283-.342.284-1.358l.001-.91.91-.001c1.028-.001 1.121-.021 1.363-.297.166-.189.207-.297.207-.542 0-.249-.053-.387-.212-.553-.249-.261-.273-.266-1.318-.28l-.95-.013v-.898c0-.978-.019-1.085-.232-1.31-.241-.254-.672-.345-.948-.2"
      fillRule="evenodd"
    />
  </svg>
);

export const IconFilter = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconFilter"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 20 20"
    role="img"
    {...props}
  >
    <path
      d="M2.65 1.703c-.661.068-1.1.313-1.361.759-.406.692-.316 1.334.292 2.091.117.145 1.406 1.598 2.866 3.228L7.1 10.746v3.157c0 3.053.002 3.164.066 3.371.125.403.46.711.889.817.208.051.243.051.487 0 .248-.051 3.308-1.247 3.703-1.447.22-.111.442-.343.549-.571l.089-.19.01-2.57.009-2.57 2.652-2.963a308.981 308.981 0 0 0 2.867-3.23c.259-.32.467-.723.519-1.008.083-.452-.108-1.016-.464-1.37-.295-.293-.59-.411-1.171-.47-.417-.043-14.245-.041-14.655.001m14.564 1.659c.027.044-.171.27-2.963 3.388-1.445 1.613-2.67 3-2.722 3.082-.053.081-.13.231-.171.333-.074.185-.075.191-.091 2.647l-.017 2.461-1.2.481c-.66.264-1.226.488-1.258.498-.054.018-.058-.153-.066-2.942l-.009-2.96-.076-.187a2.123 2.123 0 0 0-.173-.333c-.053-.081-1.278-1.467-2.721-3.08-2.939-3.286-2.989-3.343-2.962-3.386.024-.039 14.404-.042 14.429-.002"
      fillRule="evenodd"
    />
  </svg>
);

export const IconFolderCheck = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconFolderCheck"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M21 11.8C21 10.9436 20.9997 10.3614 20.9629 9.91134C20.9271 9.47293 20.8619 9.24841 20.7822 9.09201C20.5905 8.71576 20.2845 8.40972 19.9082 8.21798C19.7518 8.13829 19.5273 8.07314 19.0889 8.03732C18.6388 8.00056 18.0566 8.00021 17.2002 8.00021H3V16.2004C3 17.0568 3.00035 17.639 3.03711 18.0891C3.07293 18.5275 3.13809 18.752 3.21778 18.9084C3.40951 19.2847 3.71555 19.5907 4.0918 19.7824C4.2482 19.8621 4.47272 19.9273 4.91114 19.9631C5.36117 19.9999 5.94342 20.0002 6.79981 20.0002H17.2002C18.0566 20.0002 18.6388 19.9999 19.0889 19.9631C19.5273 19.9273 19.7518 19.8621 19.9082 19.7824C20.2845 19.5907 20.5905 19.2847 20.7822 18.9084C20.8619 18.752 20.9271 18.5275 20.9629 18.0891C20.9997 17.639 21 17.0568 21 16.2004V11.8ZM14.793 10.7932C15.1835 10.4027 15.8165 10.4027 16.207 10.7932C16.5976 11.1837 16.5976 11.8167 16.207 12.2072L11.707 16.7072C11.3165 17.0978 10.6835 17.0978 10.293 16.7072L8.29297 14.7072C7.90245 14.3167 7.90245 13.6837 8.29297 13.2932C8.6835 12.9027 9.31651 12.9027 9.70704 13.2932L11 14.5861L14.793 10.7932ZM5.2002 4.00021C4.62365 4.00021 4.25112 4.00148 3.96778 4.02463C3.69619 4.04682 3.59534 4.0844 3.5459 4.10959C3.35793 4.20543 3.20522 4.35814 3.10938 4.54611C3.08419 4.59555 3.04662 4.6964 3.02442 4.96798C3.00406 5.21713 3.00142 5.53511 3.00098 6.00021H11.3818L10.9902 5.21603C10.6368 4.50922 10.555 4.37464 10.4639 4.28537C10.358 4.1817 10.2299 4.10322 10.0898 4.0549C9.96925 4.01333 9.81244 4.00021 9.02247 4.00021H5.2002ZM23 16.2004C23 17.0239 23.001 17.7018 22.9561 18.2522C22.9101 18.8142 22.8117 19.3313 22.5645 19.8166C22.181 20.5691 21.5689 21.1812 20.8164 21.5647C20.3311 21.8119 19.814 21.9103 19.252 21.9563C18.7016 22.0012 18.0237 22.0002 17.2002 22.0002H6.79981C5.97632 22.0002 5.29843 22.0012 4.74805 21.9563C4.186 21.9103 3.6689 21.8119 3.1836 21.5647C2.43109 21.1812 1.81902 20.5691 1.43555 19.8166C1.18828 19.3313 1.08988 18.8142 1.04395 18.2522C0.998982 17.7018 1 17.0239 1 16.2004V6.20041C1 5.65685 0.998931 5.18857 1.03028 4.8049C1.06259 4.40964 1.1344 4.0162 1.32715 3.63791C1.61473 3.07368 2.07348 2.61493 2.6377 2.32736C3.016 2.13461 3.40943 2.0628 3.80469 2.03048C4.18836 1.99914 4.65665 2.00021 5.2002 2.00021H9.02247C9.66781 2.00021 10.229 1.98728 10.7422 2.16427C11.1625 2.30926 11.5456 2.54555 11.8633 2.85666C12.2511 3.23647 12.4907 3.7443 12.7793 4.3215L13.6182 6.00021H17.2002C18.0237 6.00021 18.7016 5.99919 19.252 6.04416C19.814 6.09008 20.3311 6.18848 20.8164 6.43576C21.5689 6.81923 22.181 7.4313 22.5645 8.1838C22.8117 8.66911 22.9101 9.1862 22.9561 9.74826C23.001 10.2986 23 10.9765 23 11.8V16.2004Z" />
  </svg>
);

export const IconHamburger = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconHamburger"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="m 2.9999999,7.5 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 H 21 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z m 0,7 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 H 21 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z" />
    <path d="M 3,8.4545661 H 21 M 3,15.454566 h 18" />
  </svg>
);

export const IconHourglass = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconHourglass"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M20,23H4c-.6,0-1-.4-1-1s.4-1,1-1h1v-1.8c0-.9,0-1.4.1-1.9.1-.5.3-.9.6-1.3.3-.4.7-.7,1.4-1.3l3.4-2.8-3.4-2.8c-.7-.6-1.1-.9-1.4-1.3-.3-.4-.5-.8-.6-1.3-.1-.5-.1-1-.1-1.9v-1.8h-1c-.6,0-1-.4-1-1s.4-1,1-1h16c.6,0,1,.4,1,1s-.4,1-1,1h-1v1.8c0,.9,0,1.4-.1,1.9-.1.5-.3.9-.6,1.3-.3.4-.7.7-1.3,1.3l-3.4,2.8,3.4,2.8c.7.6,1.1.9,1.4,1.3.3.4.5.8.6,1.3.1.5.1,1,.1,1.9v1.8h1c.6,0,1,.4,1,1s-.4,1-1,1ZM7,21h10v-1.8c0-.7,0-1.1,0-1.4,0-.2-.2-.4-.3-.6-.2-.2-.4-.5-1-.9l-3.6-3-3.6,3c-.6.5-.9.7-1,.9-.1.2-.2.4-.3.6,0,.3,0,.6,0,1.4v1.8ZM7,3v1.8c0,.7,0,1.1,0,1.4,0,.2.2.4.3.6.2.2.4.5,1,.9l3.6,3,3.6-3c.6-.5.9-.7,1-.9.1-.2.2-.4.3-.6,0-.3,0-.6,0-1.4v-1.8H7Z" />
  </svg>
);

export const IconInfo = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconInfo"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M12,23c-6.1,0-11-4.9-11-11S5.9,1,12,1s11,4.9,11,11-4.9,11-11,11ZM12,3C7,3,3,7,3,12s4,9,9,9,9-4,9-9S17,3,12,3ZM12,17c-.6,0-1-.4-1-1v-4c0-.6.4-1,1-1s1,.4,1,1v4c0,.6-.4,1-1,1ZM12,9c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z" />
  </svg>
);

export const IconLaptop = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconLaptop"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="m 6.1992187,3 c -1.12011,0 -1.818179,-0.052092 -2.5605468,0.3261719 -0.5643916,0.2875573 -1.0249427,0.7481084 -1.3125,1.3125 C 1.9479054,5.3810453 2,6.0791188 2,7.1992187 V 15.347656 C 1.5658471,15.611734 1.2031937,15.979217 1.0683594,16.482422 0.98164592,16.805911 1,17.023984 1,17.333984 c 0,0.62 -0.0191869,0.992786 0.1015625,1.44336 0.2769791,1.033747 1.0874355,1.844026 2.1210938,2.121093 a 1.0001,1.0001 0 0 0 0.00195,0 C 3.6750561,21.01905 4.0460356,21 4.6660156,21 H 19.333984 c 0.62,0 0.990948,0.01907 1.441407,-0.101563 a 1.0001,1.0001 0 0 0 0.002,0 c 1.033674,-0.277064 1.844029,-1.087419 2.121093,-2.121093 a 1.0001,1.0001 0 0 0 0,-0.002 C 23.019068,18.324932 23,17.953984 23,17.333984 c 0,-0.31 0.01847,-0.527935 -0.06836,-0.851562 C 22.796863,15.979046 22.434182,15.611731 22,15.347656 V 7.1992187 C 22,6.0791188 22.052115,5.3810508 21.673828,4.6386719 21.386272,4.0741651 20.925654,3.6137188 20.361328,3.3261719 19.618932,2.9478761 18.920881,3 17.800781,3 Z m 0,2 H 17.800781 c 1.1201,0 1.53914,0.051691 1.652344,0.109375 0.188274,0.095933 0.341656,0.2493467 0.4375,0.4375 C 19.948338,5.6601361 20,6.0791188 20,7.1992187 V 15 H 4 V 7.1992187 C 4,6.0791187 4.0516615,5.6601416 4.109375,5.546875 4.2052977,5.3586066 4.3586066,5.2052977 4.546875,5.109375 4.6601472,5.0516587 5.0791088,5 6.1992187,5 Z M 3,17 c -0.06915,0.01854 0.023994,0 0.3339844,0 H 20.666016 c 0.31,0 0.403411,0.01863 0.333984,0 -0.01863,-0.06943 0,0.02398 0,0.333984 0,0.618694 -0.01765,0.865012 -0.0332,0.923828 -0.09294,0.346727 -0.362258,0.616049 -0.708985,0.708985 C 20.198996,18.982346 19.952678,19 19.333984,19 H 4.6660156 c -0.6186737,0 -0.8649408,-0.01764 -0.9238281,-0.0332 h -0.00195 C 3.3942299,18.873512 3.1259558,18.605939 3.0332031,18.259766 a 1.0001,1.0001 0 0 0 0,-0.002 C 3.0176525,18.199786 3,17.953984 3,17.333984 3,17.023984 3.0185735,16.930711 3,17 Z" />
  </svg>
);

export const IconLock = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconLock"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M11.5 2.043c-2.758.216-5.014 2.334-5.42 5.089-.025.171-.058.7-.073 1.176l-.027.864-.257.07c-1.156.316-2.245 1.457-2.52 2.638-.169.727-.181.954-.181 3.62 0 2.666.012 2.893.181 3.62.289 1.245 1.429 2.384 2.68 2.677.778.183.79.183 6.117.183s5.339 0 6.117-.183c.72-.169 1.484-.665 1.983-1.289.459-.573.693-1.158.825-2.068.071-.481.071-5.401.001-5.88-.134-.908-.365-1.489-.825-2.07-.449-.567-1.191-1.075-1.824-1.248l-.257-.07-.027-.864a15.432 15.432 0 0 0-.073-1.176 5.965 5.965 0 0 0-1.746-3.416c-1.26-1.221-2.91-1.812-4.674-1.673m1.56 2.094c1.396.41 2.385 1.399 2.804 2.803.098.328.109.435.126 1.21l.019.85H7.991l.019-.85c.017-.775.028-.882.126-1.21.204-.683.493-1.196.944-1.675a3.955 3.955 0 0 1 1.716-1.083c.501-.156.688-.179 1.324-.164.483.011.64.031.94.119m4.517 6.955c.342.102.586.247.835.496.257.256.4.503.497.856.065.233.071.503.071 3.056s-.006 2.823-.071 3.056c-.097.353-.24.6-.497.856a1.78 1.78 0 0 1-.856.497c-.239.066-.613.071-5.556.071s-5.317-.005-5.556-.071a1.78 1.78 0 0 1-.856-.497 1.78 1.78 0 0 1-.497-.856c-.065-.233-.071-.503-.071-3.056s.006-2.823.071-3.056c.097-.352.242-.603.49-.849.346-.342.645-.486 1.145-.553.14-.018 2.585-.03 5.434-.027 4.819.006 5.196.012 5.417.077m-5.999 2.523c-.216.1-.391.28-.494.505-.054.119-.064.329-.064 1.38 0 1.354.003 1.371.242 1.656.357.422 1.119.422 1.476 0 .239-.285.242-.302.242-1.656 0-1.051-.01-1.261-.064-1.38a1 1 0 0 0-1.338-.505" />
  </svg>
);

export const IconLogs = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconLogs"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M15.2,23h-6.4c-1.84,0-2.76,0-3.62-.44-.76-.39-1.36-.99-1.75-1.75-.44-.86-.44-1.78-.44-3.62V6.8c0-1.84,0-2.76.44-3.62.39-.76.99-1.36,1.75-1.75.86-.44,1.78-.44,3.62-.44h3.21c.79,0,1.22,0,1.68.11.41.1.8.26,1.16.48.4.25.71.55,1.26,1.1l3.2,3.2c.55.55.86.86,1.11,1.27.22.36.38.75.48,1.16.11.46.11.89.11,1.68v7.21c0,1.84,0,2.76-.44,3.62-.38.76-.99,1.36-1.75,1.75-.86.44-1.78.44-3.62.44ZM8.8,3c-1.47,0-2.28,0-2.71.22-.38.19-.68.5-.87.87-.22.43-.22,1.24-.22,2.71v10.4c0,1.47,0,2.28.22,2.71.19.38.5.68.87.87.43.22,1.24.22,2.71.22h6.4c1.47,0,2.28,0,2.71-.22.38-.19.68-.5.87-.87.22-.43.22-1.24.22-2.71v-7.21c0-.47,0-.77-.02-.99h-3.38c-.65,0-1.08,0-1.51-.22-.38-.19-.68-.5-.87-.87-.22-.43-.22-.86-.22-1.51v-3.38c-.22-.02-.52-.02-.99-.02h-3.21ZM15,4.41v1.99c0,.28,0,.57.02.65.01-.05.3-.05.58-.05h1.99l-2.59-2.59ZM14,18h-6c-.55,0-1-.45-1-1s.45-1,1-1h6c.55,0,1,.45,1,1s-.45,1-1,1ZM16,14h-8c-.55,0-1-.45-1-1s.45-1,1-1h8c.55,0,1,.45,1,1s-.45,1-1,1Z" />
  </svg>
);

export const IconMinus = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconMinus"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 14 14"
    role="img"
    {...props}
  >
    <path d="M2.730 6.023 C 2.454 6.069,2.147 6.301,2.023 6.559 C 1.898 6.817,1.891 7.154,2.005 7.408 C 2.071 7.557,2.224 7.732,2.378 7.835 C 2.650 8.017,2.334 8.006,7.082 7.998 L 11.305 7.992 11.437 7.938 C 11.696 7.834,11.920 7.609,12.019 7.356 C 12.092 7.167,12.093 6.834,12.020 6.646 C 11.951 6.470,11.831 6.318,11.662 6.193 C 11.387 5.991,11.817 6.009,7.070 6.005 C 4.629 6.003,2.804 6.011,2.730 6.023 " />
  </svg>
);

export const IconPencil = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconPencil"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 20 20"
    role="img"
    {...props}
  >
    <path
      d="M14.833.864a.836.836 0 0 0-.575.452c-.096.19-.093.517.007.717.105.211 3.491 3.597 3.702 3.702a.847.847 0 0 0 .945-.156.848.848 0 0 0 .156-.946c-.099-.198-3.49-3.596-3.685-3.692a.951.951 0 0 0-.55-.077M12.2 3.553c-.219.08-.344.148-.517.285-.229.181-9.086 9.043-9.24 9.245-.149.197-.3.478-.377.702-.038.109-.325 1.136-.639 2.282-.447 1.636-.57 2.126-.569 2.284a.783.783 0 0 0 .809.793c.133-.001.764-.16 2.316-.587 1.174-.322 2.2-.61 2.282-.639.284-.102.567-.288.908-.599.189-.171 2.302-2.275 4.696-4.674 4.97-4.981 4.581-4.544 4.581-5.145 0-.56.023-.528-1.582-2.144-1.343-1.353-1.629-1.617-1.885-1.737-.132-.063-.668-.108-.783-.066m1.383 2.88L14.65 7.5l-4.383 4.386c-2.411 2.412-4.436 4.412-4.5 4.446-.147.075-2.862.817-2.89.789-.018-.018.117-.536.647-2.471l.118-.433 4.42-4.425A804.744 804.744 0 0 1 12.5 5.367c.009 0 .497.48 1.083 1.066"
      fillRule="evenodd"
    />
  </svg>
);

export const IconPlus = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconPlus"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 20 20"
    role="img"
    {...props}
  >
    <path d="M9.768 3.37a.905.905 0 0 0-.564.58c-.026.092-.037.915-.037 2.674v2.541l-2.609.009c-2.914.01-2.715-.006-2.969.248a.716.716 0 0 0-.237.578c0 .252.062.403.237.578.254.254.055.238 2.969.248l2.607.009.009 2.607c.01 2.914-.006 2.715.248 2.969a.716.716 0 0 0 .578.237.716.716 0 0 0 .578-.237c.254-.254.238-.055.248-2.969l.009-2.607 2.607-.009c2.914-.01 2.715.006 2.969-.248a.716.716 0 0 0 .237-.578.716.716 0 0 0-.237-.578c-.254-.254-.055-.238-2.969-.248l-2.607-.009-.009-2.607c-.009-2.443-.013-2.616-.07-2.73a1.046 1.046 0 0 0-.412-.412.997.997 0 0 0-.576-.046" />
  </svg>
);

export const IconPrinter = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconPrinter"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 20 20"
    role="img"
    {...props}
  >
    <path
      d="M6.633.868c-.81.054-1.23.229-1.716.715-.345.345-.513.627-.619 1.039-.079.306-.129 1.014-.13 1.831l-.001.57-.329.04c-.755.091-1.26.288-1.763.686-.512.405-.934 1.055-1.073 1.651-.14.605-.149.791-.151 3.15-.001 1.711.01 2.324.042 2.5.053.289.189.712.3.933a3.493 3.493 0 0 0 1.49 1.491c.371.185.931.325 1.305.326h.172l.022.525c.039.914.127 1.279.416 1.715.192.291.442.538.73.722.269.172.497.257.883.33.278.053.62.058 3.789.058s3.511-.005 3.789-.058c.169-.032.389-.089.491-.127.441-.165.938-.595 1.196-1.034.229-.391.304-.756.344-1.673l.02-.458h.172c.374-.001.934-.141 1.305-.326A3.537 3.537 0 0 0 18.8 14c.116-.228.257-.668.306-.957.061-.359.06-4.618-.001-5.06-.105-.76-.302-1.257-.689-1.74-.549-.687-1.26-1.06-2.249-1.18l-.323-.039-.021-.937c-.03-1.308-.094-1.633-.421-2.127-.274-.414-.704-.769-1.124-.926C13.812.86 13.793.859 10.3.849 8.512.844 6.862.853 6.633.868M13.7 2.579a.914.914 0 0 1 .378.371c.068.126.072.185.083 1.092l.011.958H5.828l.011-.958c.01-.858.017-.971.073-1.075a.803.803 0 0 1 .555-.436c.064-.013 1.691-.022 3.616-.019 3.346.004 3.505.007 3.617.067m2.614 4.164c.285.085.489.206.696.414.208.208.329.412.412.695.052.178.059.435.07 2.489.008 1.507 0 2.356-.023 2.483-.114.626-.674 1.19-1.299 1.309-.353.067-.327.098-.35-.425-.04-.884-.117-1.251-.344-1.639-.257-.439-.755-.869-1.196-1.034-.462-.173-.506-.175-3.813-.192-1.945-.01-3.299-.003-3.667.019-.989.06-1.366.204-1.883.721-.527.527-.664.893-.723 1.934a9 9 0 0 1-.048.647 1.685 1.685 0 0 1-1.614-1.341c-.024-.128-.032-.956-.023-2.482.013-2.492.012-2.476.206-2.832.106-.195.38-.481.573-.597.172-.105.394-.176.651-.21.116-.015 2.903-.025 6.194-.023 5.621.005 5.996.009 6.181.064m-4.165 1.269c-.297.139-.457.397-.457.738 0 .341.16.599.457.738l.168.078h2.866l.168-.078c.297-.139.457-.397.457-.738 0-.341-.16-.599-.457-.738l-.168-.078h-2.866l-.168.078m1.551 4.567a.914.914 0 0 1 .378.371c.071.132.072.15.072 2.05s-.001 1.918-.072 2.05a.914.914 0 0 1-.378.371c-.112.06-.268.062-3.7.062-3.432 0-3.588-.002-3.7-.062a.914.914 0 0 1-.378-.371c-.071-.132-.072-.15-.072-2.05 0-1.806.004-1.923.062-2.033a.803.803 0 0 1 .555-.436c.064-.013 1.691-.022 3.616-.019 3.346.004 3.505.007 3.617.067"
      fillRule="evenodd"
    />
  </svg>
);

export const IconSettings = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconSettings"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 40 40"
    role="img"
    {...props}
  >
    <path d="M18.823 1.995a4.544 4.544 0 0 0-2.816 2.267c-.339.653-.467 1.144-.519 1.994-.059.963-.272 1.247-.996 1.328-.425.048-.576-.014-1.103-.455-1.004-.841-1.845-1.16-3.056-1.158-.866.001-1.258.093-2.066.484-.378.183-.641.381-1.075.81-.492.486-.62.661-.877 1.202-.383.803-.477 1.203-.475 2.033.002 1.111.387 2.103 1.162 2.998.222.256.419.541.438.633l.059.289c.043.219-.173.706-.403.908-.238.209-.364.242-1.138.302-1.073.082-1.976.513-2.796 1.332-.95.95-1.341 1.989-1.278 3.395.055 1.242.417 2.064 1.291 2.936.849.848 1.641 1.209 2.892 1.317.452.039.861.112.998.178a.962.962 0 0 1 .535.86c0 .361-.057.473-.508 1.006a4.89 4.89 0 0 0-.968 1.746c-.201.651-.216 1.822-.032 2.433.248.823.57 1.365 1.173 1.975.486.492.661.62 1.202.877.803.383 1.203.477 2.033.475 1.11-.002 2.103-.387 2.996-1.161.258-.223.571-.43.706-.466.355-.096.861.07 1.122.366.213.243.246.367.306 1.143.082 1.073.513 1.976 1.332 2.796.948.948 1.985 1.339 3.395 1.281 1.221-.051 2.063-.422 2.935-1.294.848-.848 1.209-1.64 1.318-2.892.039-.452.112-.861.178-.998a.962.962 0 0 1 .86-.535c.361 0 .473.057 1.006.508a4.89 4.89 0 0 0 1.746.968c.651.201 1.822.216 2.433.032.823-.248 1.365-.57 1.975-1.173.492-.486.62-.661.877-1.202.383-.803.477-1.203.475-2.033-.002-1.111-.387-2.103-1.162-2.998-.222-.256-.419-.541-.438-.633l-.063-.308c-.04-.204.238-.705.481-.867.159-.105.359-.15.804-.179 1.251-.081 2.19-.489 3.015-1.313.571-.57.94-1.156 1.155-1.835.122-.387.148-.622.148-1.367s-.026-.98-.148-1.367c-.337-1.063-1.209-2.104-2.189-2.613-.678-.352-1.162-.479-2.019-.532-.963-.059-1.247-.272-1.328-.996-.048-.425.014-.576.455-1.103.841-1.004 1.16-1.845 1.158-3.056-.001-.866-.093-1.258-.484-2.066-.183-.378-.381-.641-.81-1.075-.486-.492-.661-.62-1.202-.877-.803-.383-1.203-.477-2.033-.475-1.11.002-2.103.387-2.995 1.16-.255.22-.569.43-.698.466-.425.117-.966-.126-1.166-.522-.049-.097-.107-.436-.128-.753a6.683 6.683 0 0 0-.148-1c-.361-1.398-1.579-2.685-2.965-3.135-.635-.206-1.926-.237-2.577-.061m1.812 2.97c.279.114.631.481.768.801.063.148.132.536.154.872.074 1.131.47 1.99 1.26 2.736 1.541 1.453 3.859 1.466 5.462.03.684-.614 1.247-.746 1.892-.445.577.268.894.774.895 1.426.001.407-.131.673-.615 1.24-.966 1.132-1.263 2.401-.894 3.819.214.821.45 1.233 1.041 1.824.793.791 1.79 1.196 2.958 1.2.485.002.85.148 1.172.47.296.296.419.607.419 1.062 0 .455-.123.766-.42 1.063-.322.322-.673.449-1.365.494-1.136.075-1.99.47-2.746 1.271-.716.76-1.083 1.694-1.083 2.761 0 .962.369 1.909 1.036 2.656.642.722.777 1.271.472 1.926-.268.577-.774.894-1.426.895-.407.001-.673-.131-1.24-.615-.828-.706-1.703-1.048-2.688-1.05-.653-.001-1.085.099-1.744.405-.448.208-.66.361-1.082.784-.79.789-1.186 1.722-1.192 2.81-.004.603-.103.901-.41 1.234-.344.373-.649.513-1.131.517a1.46 1.46 0 0 1-1.243-.63c-.199-.277-.23-.383-.314-1.097-.051-.435-.143-.941-.205-1.124-.552-1.646-2.137-2.767-3.912-2.767a4.006 4.006 0 0 0-2.699 1.032c-.719.646-1.27.782-1.926.476-.577-.268-.894-.774-.895-1.426-.001-.407.131-.673.614-1.239.689-.808.968-1.486 1.03-2.509.071-1.165-.312-2.151-1.17-3.008-.787-.788-1.721-1.184-2.808-1.19-.741-.005-1.155-.204-1.535-.738-.307-.431-.289-1.181.039-1.681.284-.432.597-.576 1.481-.68.43-.05.932-.142 1.115-.204a3.996 3.996 0 0 0 2.431-2.293c.633-1.536.367-3.13-.727-4.352-.614-.684-.746-1.247-.445-1.892.268-.577.774-.894 1.426-.895.407-.001.673.131 1.239.614 1.116.952 2.388 1.259 3.78.912.782-.196 1.28-.474 1.834-1.025.765-.761 1.131-1.559 1.198-2.614.055-.857.082-.978.282-1.275.445-.659 1.184-.883 1.917-.581m-1.724 8.634c-2.128.385-3.993 1.841-4.833 3.771-.423.971-.51 1.42-.51 2.63 0 .948.022 1.173.153 1.63.665 2.311 2.24 3.914 4.537 4.618.529.163.67.177 1.742.177 1.076 0 1.212-.014 1.75-.179 2.239-.686 3.812-2.26 4.495-4.496.163-.531.179-.685.183-1.717.004-.992-.014-1.199-.148-1.663-.669-2.315-2.265-3.937-4.538-4.613-.475-.141-.743-.175-1.542-.194-.532-.012-1.112.004-1.289.036m2.087 3.045c.474.132.766.284 1.193.622 1.46 1.154 1.74 3.336.619 4.822a3.502 3.502 0 0 1-5.62-4.176c.9-1.19 2.352-1.674 3.808-1.268" />
  </svg>
);

export const IconThumbsUp = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconThumbsUp"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M17.4,23H4c-1.7,0-3-1.3-3-3v-7c0-1.7,1.3-3,3-3h2.4l3.5-7.9c.3-.7.9-1.1,1.7-1.1,1.9,0,3.5,1.6,3.5,3.5v3.5h3.5c1.2,0,2.3.5,3,1.4s1.1,2.1.9,3.2l-1.1,7c-.3,2-2,3.4-4,3.4ZM8,21h9.4c1,0,1.8-.7,2-1.7l1.1-7c0-.6,0-1.2-.5-1.6-.4-.4-.9-.7-1.5-.7h-3.5c-1.1,0-2-.9-2-2v-3.5c0-.8-.6-1.4-1.4-1.5l-3.5,7.8c0,.1-.1.2-.2.3v9.9ZM4,12c-.6,0-1,.4-1,1v7c0,.6.4,1,1,1h2v-9h-2Z" />
  </svg>
);

export const IconTrash = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconTrash"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M7,5C7.007,3.768 7.075,3.133 7.327,2.638C7.615,2.074 8.074,1.615 8.638,1.327C9.159,1.061 9.835,1 11.2,1L12.8,1C14.165,1 14.841,1.061 15.362,1.327C15.926,1.615 16.385,2.074 16.673,2.638C16.925,3.133 16.993,3.768 17,5L21,5C21.552,5 22,5.448 22,6C22,6.552 21.552,7 21,7L20,7L20,17.2C20,19.125 19.939,20.081 19.564,20.816C19.181,21.569 18.569,22.181 17.816,22.564C17.081,22.939 16.125,23 14.2,23L9.8,23C7.875,23 6.919,22.939 6.184,22.564C5.431,22.181 4.819,21.569 4.436,20.816C4.061,20.081 4,19.125 4,17.2L4,7L3,7C2.448,7 2,6.552 2,6C2,5.448 2.448,5 3,5L7,5ZM18,7L6,7L6,17.2C6,18.636 5.939,19.359 6.218,19.908C6.41,20.284 6.716,20.59 7.092,20.782C7.64,21.061 8.364,21 9.8,21L14.2,21C15.636,21 16.36,21.061 16.908,20.782C17.284,20.59 17.59,20.284 17.782,19.908C18.061,19.36 18,18.636 18,17.2L18,7ZM8.999,5L15.001,5C15.008,4.254 15.048,3.854 14.891,3.546C14.795,3.358 14.642,3.205 14.454,3.109C14.119,2.938 13.676,3 12.8,3L11.2,3C10.324,3 9.881,2.938 9.546,3.109C9.358,3.205 9.205,3.358 9.109,3.546C8.952,3.854 8.992,4.254 8.999,5ZM13,11.5C13,10.948 13.448,10.5 14,10.5C14.552,10.5 15,10.948 15,11.5L15,16.5C15,17.052 14.552,17.5 14,17.5C13.448,17.5 13,17.052 13,16.5L13,11.5ZM9,11.5C9,10.948 9.448,10.5 10,10.5C10.552,10.5 11,10.948 11,11.5L11,16.5C11,17.052 10.552,17.5 10,17.5C9.448,17.5 9,17.052 9,16.5L9,11.5Z" />
  </svg>
);

export const IconUser = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconUser"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M20,22c-.6,0-1-.4-1-1,0-1.3,0-1.9-.1-2.4-.3-1-1-1.7-2-2-.4-.1-1.1-.1-2.4-.1h-5c-1.3,0-1.9,0-2.4.1-1,.3-1.7,1-2,2-.1.4-.1,1.1-.1,2.4s-.4,1-1,1-1-.4-1-1c0-1.5,0-2.2.2-3,.5-1.6,1.7-2.8,3.3-3.3.7-.2,1.5-.2,3-.2h5c1.5,0,2.2,0,3,.2,1.6.5,2.8,1.7,3.3,3.3.2.7.2,1.5.2,3s-.4,1-1,1ZM12,13c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5,5.5,2.5,5.5,5.5-2.5,5.5-5.5,5.5ZM12,4c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5,3.5-1.6,3.5-3.5-1.6-3.5-3.5-3.5Z" />
  </svg>
);

export const IconUsers = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconUsers"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M22,22c-.55,0-1-.45-1-1v-2c0-1.37-.92-2.56-2.25-2.91-.54-.14-.86-.68-.72-1.22.14-.54.69-.86,1.22-.72,2.21.57,3.75,2.56,3.75,4.84v2c0,.55-.45,1-1,1ZM17,22c-.55,0-1-.45-1-1,0-1.73,0-2.6-.23-3.15-.3-.73-.89-1.32-1.62-1.62-.55-.23-1.47-.23-3.15-.23h-3c-1.73,0-2.6,0-3.15.23-.73.3-1.32.89-1.62,1.62-.23.55-.23,1.42-.23,3.15,0,.55-.45,1-1,1s-1-.45-1-1c0-1.99,0-3,.38-3.91.5-1.22,1.49-2.2,2.71-2.71.92-.38,1.92-.38,3.91-.38h3c1.99,0,3,0,3.91.38,1.23.51,2.19,1.47,2.71,2.71.38.92.38,1.92.38,3.91,0,.55-.45,1-1,1ZM9.5,12c-2.76,0-5-2.24-5-5s2.24-5,5-5,5,2.24,5,5-2.24,5-5,5ZM9.5,4c-1.65,0-3,1.35-3,3s1.35,3,3,3,3-1.35,3-3-1.35-3-3-3ZM15.5,11.71c-.4,0-.77-.24-.93-.63-.21-.51.04-1.09.55-1.3,1.14-.46,1.88-1.55,1.88-2.78s-.74-2.32-1.88-2.78c-.51-.21-.76-.79-.55-1.3s.79-.76,1.3-.55c1.9.77,3.12,2.59,3.12,4.64s-1.23,3.87-3.12,4.64c-.12.05-.25.07-.38.07Z" />
  </svg>
);

export const IconWarning = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconWarning"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M20.2,21.5H3.8c-1.1,0-1.7,0-2.2-0.4c-0.5-0.3-0.8-0.8-0.8-1.4c-0.1-0.6,0.2-1.2,0.8-2.1L9.8,3.4l0,0l0.9,0.5L9.8,3.4c0.5-0.9,0.8-1.5,1.4-1.7c0.5-0.2,1.1-0.2,1.6,0c0.6,0.3,0.9,0.8,1.4,1.7l8.2,14.2c0.5,0.9,0.8,1.5,0.8,2.1c-0.1,0.6-0.4,1.1-0.8,1.4C21.9,21.5,21.3,21.5,20.2,21.5z M2.8,19.5c0.2,0,0.6,0,1,0h16.4c0.4,0,0.8,0,1,0c-0.1-0.2-0.3-0.5-0.5-0.9L12.5,4.4c-0.2-0.3-0.4-0.7-0.5-0.9c-0.1,0.2-0.3,0.5-0.5,0.9l-0.9-0.5l0.9,0.5L3.3,18.6C3.1,18.9,2.9,19.3,2.8,19.5z M12,18c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,18,12,18z M12,14c-0.6,0-1-0.4-1-1V9c0-0.6,0.4-1,1-1s1,0.4,1,1v4C13,13.6,12.6,14,12,14z" />
  </svg>
);

export const IconWarningSquare = (props: SVGAttributes<SVGElement>) => (
  <svg
    aria-hidden="true"
    data-icon="IconWarningSquare"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 24 24"
    role="img"
    {...props}
  >
    <path d="M22,0H2C.9,0,0,.9,0,2v20c0,1.1.9,2,2,2h20c1.1,0,2-.9,2-2V2c0-1.1-.9-2-2-2ZM10.7,6.5h2.7v2.9l-.3,4.6h-2l-.3-4.6v-2.9ZM13.4,17.5h-2.8v-2.7h2.8v2.7Z" />
  </svg>
);
